<template>
  <div>
    <RSSItem v-for="data in displayData" :key="data.link" :data="data"></RSSItem>
    <div class="view-more-wrapper" v-if="displayData && displayData.length">
      <div class="view-more" @click="moreRSS = !moreRSS">{{moreRSS?'VIEW LESS':'VIEW MORE'}}</div>
    </div>
    <Spin size="large" class="spinner" v-else></Spin>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RSSItem from './RSSItem';
import smoothReflow from 'vue-smooth-reflow';
export default {
	mixins: [smoothReflow],
	data() {
		return {
			moreRSS: false
		};
	},
	computed: {
		...mapGetters('rssStore', ['rssData']),
		displayData() {
			return this.moreRSS
				? this.rssData.slice(0, 30)
				: this.rssData.slice(0, 8);
		}
	},
	mounted() {
		this.$smoothReflow();
	},
	components: {
		RSSItem
	}
};
</script>

<style lang="scss" scoped>
.spinner {
	display: flex;
	justify-content: center;
}
.view-more-wrapper {
	width: 100%;
	text-align: center;
	color: $apnic-blue;

	.view-more {
		margin: 0.5rem;
		cursor: pointer;
		display: inline-block;
	}
}
</style>
